import { injectIntl } from 'react-intl';
import NewAccountRequest from './NewAccountRequest';
import config from './config';

export const CONFIG = config;

export default injectIntl(NewAccountRequest);
